import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['María', 'Lucas', 'Carolina', 'Andrea', 'Roberto', 'Valentina', 'Martín', 'Sofía', 'Diego', 'Camila'];
const PROVINCES = ['Buenos Aires', 'Córdoba', 'Santa Fe', 'Mendoza', 'Tucumán', 'Salta', 'Entre Ríos', 'Misiones', 'Chaco', 'San Juan'];
const PRODUCTS = ['Pack Básico', 'Pack Completo'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    province: '',
    product: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomProvince = PROVINCES[Math.floor(Math.random() * PROVINCES.length)];
      const randomProduct = Math.random() < 0.3 ? PRODUCTS[0] : PRODUCTS[1];
      setCurrentPurchase({
        name: randomName,
        province: randomProvince,
        product: randomProduct
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay
    const initialTimer = setTimeout(showPopup, 3000);
    // Recurring interval (every 8-12 seconds)
    const interval = setInterval(() => {
      showPopup();
    }, Math.floor(Math.random() * 4000) + 8000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-187">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -100,
      y: 20
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -100,
      y: 20
    }} className="fixed bottom-4 left-4 z-50 max-w-sm bg-white rounded-lg shadow-2xl border border-gray-200 p-4 flex items-start gap-3" data-id="element-188">
          <div className="mt-1 flex-shrink-0" data-id="element-189">
            <CheckCircle2 className="w-6 h-6 text-green-500" data-id="element-190" />
          </div>
          <div data-id="element-191">
            <p className="text-sm text-gray-800" data-id="element-192">
              <span className="font-bold" data-id="element-193">{currentPurchase.name}</span> de{' '}
              <span className="font-bold" data-id="element-194">{currentPurchase.province}</span>,
              Argentina acaba de comprar el
            </p>
            <p className="text-sm font-bold text-blue-600 mt-1" data-id="element-195">
              {currentPurchase.product}!
            </p>
            <p className="text-xs text-gray-400 mt-1" data-id="element-196">Hace unos segundos</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}